module.exports = __webpack_public_path__ + "static/img/login_bg.fb448635.png";